import { API_BASE, http } from "./http";

export type PosProductRow = {
  id: string;
  code: string;
  name: string;
  ean?: string | null;
  description?: string | null;
  unitPrice: number | string;
  listPrice?: number | string | null;
  vatRate?: number | string | null;
  stockQty?: number | string | null;
  isWeighable?: boolean;
  isActive?: boolean;
  sortOrder?: number;
  color?: string | null;
  category?: { code: string; name: string; color?: string | null } | null;
  promoLabel?: string | null;
  promoPrice?: number | null;
};

export type UpsertPosProductPayload = {
  code: string;
  name: string;
  unitPrice: number;
  ean?: string;
  description?: string;
  categoryCode?: string;
  listPrice?: number;
  vatRate?: number;
  stockQty?: number;
  isWeighable?: boolean;
  isActive?: boolean;
  sortOrder?: number;
  color?: string;
};

function q(params: Record<string, string | number | undefined | null>) {
  const sp = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v == null || v === "") return;
    sp.set(k, String(v));
  });
  const s = sp.toString();
  return s ? `?${s}` : "";
}

export const posProductsApi = {
  list(
    token: string,
    params?: { query?: string; categoryCode?: string; limit?: number; includeInactive?: boolean },
  ) {
    return http<PosProductRow[]>(
      `/pos/catalog/products${q({
        query: params?.query,
        categoryCode: params?.categoryCode,
        limit: params?.limit ?? 2000,
        includeInactive: params?.includeInactive ? "1" : undefined,
      })}`,
      { method: "GET" },
      token,
    );
  },

  listCategories(token: string) {
    return http<Array<{ id: string; code: string; name: string; color?: string }>>(
      "/pos/catalog/categories",
      { method: "GET" },
      token,
    );
  },

  upsert(token: string, payload: UpsertPosProductPayload) {
    return http<{ ok: boolean; product: PosProductRow }>(
      "/pos/catalog/products/upsert",
      { method: "POST", body: JSON.stringify(payload) },
      token,
    );
  },

  deactivate(token: string, code: string) {
    return http<{ ok: boolean }>(
      "/pos/catalog/products/deactivate",
      { method: "POST", body: JSON.stringify({ code }) },
      token,
    );
  },

  importCsv(token: string, csv: string, dryRun?: boolean) {
    return http<{ ok: boolean; prepared: number; synced?: number; dryRun?: boolean; sample?: unknown[] }>(
      "/pos/catalog/products/import-csv",
      { method: "POST", body: JSON.stringify({ csv, dryRun: Boolean(dryRun) }) },
      token,
    );
  },

  async downloadPlu(token: string, onlyWeighable?: boolean) {
    const res = await fetch(
      `${API_BASE}/pos/catalog/plu-export${q({ onlyWeighable: onlyWeighable ? "1" : undefined })}`,
      {
        method: "GET",
        credentials: "include",
        headers: { Authorization: `Bearer ${token}` },
      },
    );
    if (!res.ok) {
      const txt = await res.text().catch(() => "");
      throw new Error(txt || `Export PLU fallito HTTP ${res.status}`);
    }
    const data = (await res.json()) as {
      ok: boolean;
      content: string;
      filename: string;
      count: number;
      lines: string[];
    };
    return data;
  },
};
